import { CampaignStep } from '../useGetOrderedCampaignsSteps';

export function getCampaignStepURL(step: CampaignStep, campaignPrettyId: string): string {
  return `/campaign/${campaignPrettyId}/${step}`;
}
